(function ($) {
  videoCategoryDetailItemV1 = {
    formatter: $('.video-category-detail-item-v1')
  };

  Drupal.behaviors.videoCategoryDetailItemV1 = {
    get: function (key) {
      return videoCategoryDetailItemV1[key];
    },

    set: function (key, val) {
      videoCategoryDetailItemV1[key] = val;
    },

    attach: function (context, settings) {
      var self = this;
      var formatter = self.get('formatter');

      formatter.each(function () {
        var thisFormatter = $(this);
        // properly structure html output of ELC Video
        var elcVideo = thisFormatter.find('.item-video-elc-video');

        if (elcVideo.length == 1) {
        // move thumbnail
          var thumbContainer = thisFormatter.find('.item-video-thumb');

          if (thumbContainer.html().length == 0) {
            elcVideo.find('img').appendTo(thumbContainer);
          }

          // move video and controls
          var videoContainer = thisFormatter.find('.item-video-html');

          elcVideo.find('video').appendTo(videoContainer);
          elcVideo.find('.video_player_controls').appendTo(videoContainer);

          if ($('body').hasClass('device-pc')) {
          // hide leftovers on pc only
            elcVideo.hide();
          }
        } // endif

        // Mobile videos section
        if ($('body').hasClass('device-mobile')) {
          var videoVideo = thisFormatter.find('.item-video-video');

          // Loop through the video items, get its title and move it after the video HTML div, then remove the original title
          videoVideo.each(function () {
            var videoTitle = $(this).find('.item-video-title'),
              videoHtml = $(this).find('.item-video-html');

            $('<div class="item-video-title">' + videoTitle.text() + '</div>').insertAfter(videoHtml);
            $(this).find('.item-video-title').first().remove();
          });
        }
      });
    }
  };
})(jQuery);
